<template lang="pug">
  b-container.white-space(fluid="fluid")
    b-row
      b-col
        b-card#plan.ml-3(:header="plans[value.plan_name || ''].title" class="card font-weight-bold" header-class="plan-title-size text-center card font-weight-bold" footer-tag="footer")
          b-card-text
            b-row.mt-3.mb-3(align-h="around")
              .mr-3(v-if="plans[value.plan_name || ''].services.includes('neo')")
                img.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
              .mr-3(v-if="plans[value.plan_name || ''].services.includes('appsuite')")
                img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
            .text-center.mb-3
              h4.font-weight-bold （1ユーザー￥{{plans[value.plan_name || ''].price}}/月）
            b-row(align-h="center")
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="plan.label", :label-class="plan.label_class")
                .form-inline
                  b-form-input.mb-2.align-content(size="sm", :type="plan.type", v-model="value.plan_user", :placeholder="plan.placeholder", :maxlength="plan.maxlength")
                  b-form-text.ml-1.mb-2 ユーザー
                b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.plan.error_msg") {{error_msg}}
                b-form-text.description-text-position {{plan.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- AppSuite
        template(v-if="value.plan_name === 'light'")
          h5#app-suite.font-weight-bold.ml-3.form-inline(:class="title_class")
            label 業務アプリ作成ツール AppSuite（1ユーザー￥550/月）
            b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/appsuite/", target="_blank") 詳細はこちら ＞
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="app_suite.label", :label-class="app_suite.label_class", :class="data_class")
            .form-inline
              b-form-input.mb-2(size="sm", :type="app_suite.type", v-model="value.app_suite_user", :placeholder="app_suite.placeholder", :state="error_msg_list.app_suite.error_msg.length === 0 ? null : false")
              b-form-text.ml-1.mb-2 ユーザー
            b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.app_suite.error_msg") {{error_msg}}
            b-form-text.description-text-position {{app_suite.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- ウェブ会議
        h5#web-conferencing.font-weight-bold.ml-3.form-inline(:class="title_class")
          label desknet's NEO ウェブ会議（1会議室￥11,000/月）
          b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/webmtg/", target="_blank") 詳細はこちら ＞
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="web_conferencing.label", :label-class="web_conferencing.label_class", :class="data_class")
          .form-inline
            b-form-input.mb-2(size="sm", :type="web_conferencing.type", v-model="value.web_conferencing", :placeholder="web_conferencing.placeholder", :state="error_msg_list.web_conferencing.error_msg.length === 0 ? null : false")
            b-form-text.ml-1.mb-2 会議室
          b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.web_conferencing.error_msg") {{error_msg}}
          b-form-text.description-text-position {{web_conferencing.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- オプションサービス
        h5#option-service.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.option_service", @change="toggleOptionService") オプションサービス
        b-collapse#collapse-option-service(v-model="optionServiceIsOpen")
          //- RoomMgr
          b-form-checkbox.ml-4(v-model="value.option_room_mgr", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_room_mgr.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/roommgr/", target="_blank") 詳細はこちら ＞
          b-form-text.ml-5.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.option_room_mgr.error_msg") {{error_msg}}
          b-form-text.ml-5.pb-2 {{option_room_mgr.description}}
          //- 交通費・経費精算
          b-form-checkbox.ml-4(v-model="value.option_expense_settlement", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_expense_settlement.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/releases/v30/feature1.html", target="_blank") 詳細はこちら ＞
          b-form-text.ml-5.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.option_expense_settlement.error_msg") {{error_msg}}
          b-form-text.ml-5.pb-2 {{option_expense_settlement.description}}
          //- タイムカード＋CLOUZA
          b-form-checkbox.ml-4(v-model="value.clouza_check", @change="toggleClouza", :class="option_data_class", :state="error_msg_list.clouza_check.error_msg.length === 0 ? null : false")
            .form-inline
              b-form-text.label-font-size.mt-0 {{clouza_check.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/timecardp/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of error_msg_list.clouza_check.error_msg") {{error_msg}}
          b-collapse#collapse-option-clouza.sub-b-collapse(v-model="optionClouzaIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="clouza_input.label", :label-class="clouza_input.label_class")
              .form-inline
                b-form-input(size="sm", :type="clouza_input.type", v-model="value.clouza_input", :placeholder="clouza_input.placeholder", :state="error_msg_list.clouza_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 ユーザー
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.clouza_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{clouza_input.description}}
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="clouza_company_code.label", :label-class="clouza_company_code.label_class")
              b-form-input(size="sm", :type="clouza_company_code.type", v-model="value.clouza_company_code", :placeholder="clouza_company_code.placeholder", :state="error_msg_list.clouza_company_code.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.clouza_company_code.error_msg") {{error_msg}}
              b-form-text.mt-0 {{clouza_company_code.description}}
            b-form-checkbox.mb-2.ml-3(v-model="value.paid_leave_option", size="sm", :state="error_msg_list.paid_leave_option.error_msg.length === 0 ? null : false")
              b-form-text.mt-0.paid-leave-option-font {{paid_leave_option.label}}
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.paid_leave_option.error_msg") {{error_msg}}
              b-form-text.mb-2.description-text-position.paid-leave-option-description-font {{paid_leave_option.description}}
            p.mb-2.ml-3
              a(
                href="https://www.desknets.com/neo/pdf/article_timecardp.pdf",
                target="_blank"
              ) ＞ タイムカード＋CLOUZA利用約款
          //- ディスク増設
          b-form-checkbox.ml-4(v-model="value.option_disk", @change="toggleDisk", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_disk.label}}
          b-collapse#collapse-option-disk.sub-b-collapse(v-model="optionDiskIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_disk_size.label", :label-class="option_disk_size.label_class")
              .form-inline
                b-form-text.mb-2.mx-1 20GB ×
                b-form-input.mb-2.option-disk-form-class(size="sm", :type="option_disk_size.type", v-model="value.option_disk_size", @input="changeSumSize", :state="error_msg_list.option_disk_size.error_msg.length === 0 ? null : false")
                b-form-text.mb-2.mx-1 =
                b-form-text.mb-2.mx-1 {{option_disk_sum}}GB 増設
              b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.option_disk_size.error_msg") {{error_msg}}
          //- Sync for smartphones
          b-form-checkbox.ml-4(v-model="value.option_sync", @change="toggleSync", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_sync.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/sync/", target="_blank") 詳細はこちら ＞
          b-collapse#collapse-option-sync.sub-b-collapse(v-model="optionSyncIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_sync_input.label", :label-class="option_sync_input.label_class")
              .form-inline
                b-form-input.mb-2(size="sm", :type="option_sync_input.type", v-model="value.option_sync_input", :placeholder="option_sync_input.placeholder", :state="error_msg_list.option_sync_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 ユーザー
                b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.option_sync_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{option_sync_input.description}}
          //- desknet'sドライブ ディスク増設
          b-form-checkbox.ml-4(v-model="value.option_dn_drive", @change="toggleDnDrive", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_dn_drive.label}}
          b-collapse#collapse-option-dn-drive.sub-b-collapse(v-model="optionDnDriveIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_dn_drive_disk_size.label", :label-class="option_dn_drive_disk_size.label_class")
              .form-inline
                b-form-text.mb-2.mx-1 20GB ×
                b-form-input.mb-2.option-disk-form-class(size="sm", :type="option_dn_drive_disk_size.type", v-model="value.option_dn_drive_disk_size", @input="changeDnDriveSumSize", :state="error_msg_list.option_dn_drive_disk_size.error_msg.length === 0 ? null : false")
                b-form-text.mb-2.mx-1 =
                b-form-text.mb-2.mx-1 {{option_dn_drive_disk_sum}}GB 増設
              b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.option_dn_drive_disk_size.error_msg") {{error_msg}}
          b-form-group.ml-4.border-top.border-primary(style="height: 0px;")
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- セキュリティオプション
        h5#security-option.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.security_option", @change="toggleSecurityOption") セキュリティオプション
        b-collapse#collapse-security-option(v-model="securityOptionIsOpen")
          //- BASIC認証
          b-form-checkbox.ml-4(:state="error_msg_list.basic_auth.error_msg.length === 0 ? null : false", v-model="value.basic_auth", @change="toggleBasic", :class="option_data_class") {{basic_auth.label}}
            .form-inline
              b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.basic_auth.error_msg") {{error_msg}}
          b-collapse#collapse-basic.sub-b-collapse(v-model="basicIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_user.label", :label-class="basic_auth_user.label_class")
              .form-inline
                b-form-input(size="sm", :type="basic_auth_user.type", v-model="value.basic_auth_user", :placeholder="basic_auth_user.placeholder", :state="error_msg_list.basic_auth_user.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.basic_auth_user.error_msg") {{error_msg}}
            b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_password.label", :label-class="basic_auth_password.label_class")
              .form-inline
                b-form-input(size="sm", :type="basic_auth_password.type", v-model="value.basic_auth_password", :placeholder="basic_auth_password.placeholder", :state="error_msg_list.basic_auth_password.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.basic_auth_password.error_msg") {{error_msg}}
            b-form-group.white-space.align-content.mt-2(label-cols="12", label-align="left", label-size="sm", :label="basic_auth_ip.label", :label-class="basic_auth_ip.label_class")
              b-form-textarea(:state="error_msg_list.basic_auth_ip.error_msg.length === 0 ? null : false", v-model="value.basic_auth_ip", rows="4")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.basic_auth_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{basic_auth_ip.description}}
          //- 接続元IPアドレス制限
          b-form-checkbox.ml-4(:state="error_msg_list.ip_restrictions.error_msg.length === 0 ? null : false", v-model="value.ip_restrictions", @change="toggleIpRestrictions", :class="option_data_class") {{ip_restrictions.label}}
            .form-inline
              b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.ip_restrictions.error_msg") {{error_msg}}
          b-collapse#collapse-ip-restrictions.sub-b-collapse(v-model="ipRestrictionsIsOpen")
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="ip_restrictions_ip.label", :label-class="ip_restrictions_ip.label_class")
              b-form-textarea(:state="error_msg_list.ip_restrictions_ip.error_msg.length === 0 ? null : false", v-model="value.ip_restrictions_ip", rows="4")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.ip_restrictions_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{ip_restrictions_ip.description}}
          //- セキュアブラウザ
          //- b-form-checkbox.ml-4(:state="error_msg_list.secure_browser.error_msg.length === 0 ? null : false", v-model="value.secure_browser", @change="toggleSecureBrowser", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{secure_browser.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/cloud/sb/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of error_msg_list.secure_browser.error_msg") {{error_msg}}
          //- b-collapse#collapse-secure-browser.sub-b-collapse(v-model="secureBrowserIsOpen")
            b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="secure_browser_terminal.label", :label-class="secure_browser_terminal.label_class")
              b-form-radio-group(v-model="value.secure_browser_terminal", :stacked="true", @change="secureBrowserTerminalChange")
                b-form-radio.m-1(:value="secure_browser_terminal.options[0].value") {{secure_browser_terminal.options[0].text}}
                  b-form-text {{secure_browser_terminal.options[0].description}}
                b-form-radio.m-1(:value="secure_browser_terminal.options[1].value") {{secure_browser_terminal.options[1].text}}
                  b-form-text {{secure_browser_terminal.options[1].description}}
              .form-inline
                b-form-input.mb-2(size="sm", :type="secure_browser_device.type", :disabled="secureBrowserTerminalDisabled", v-model="value.secure_browser_device", :placeholder="secure_browser_device.placeholder", :state="error_msg_list.secure_browser_device.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 デバイス
              b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_browser_device.error_msg") {{error_msg}}
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="secure_browser_ip.label", :label-class="secure_browser_ip.label_class", :state="error_msg_list.secure_browser_ip.error_msg.length === 0 ? null : false")
              b-form-textarea(:state="error_msg_list.secure_browser_ip.error_msg.length === 0 ? null : false", v-model="value.secure_browser_ip", rows="4")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_browser_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{secure_browser_ip.description}}
          //- クライアント認証
          b-form-checkbox.ml-4(:state="error_msg_list.client_auth.error_msg.length === 0 ? null : false", v-model="value.client_auth", @change="toggleClientAuth", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{client_auth.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/clientcert/", target="_blank") 詳細はこちら ＞
            b-form-text.ml-3.error-message-color(v-for="(error_msg) of error_msg_list.client_auth.error_msg") {{error_msg}}
          b-collapse#collapse-client-auth.sub-b-collapse(v-model="clientAuthIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="client_auth_input.label", :label-class="client_auth_input.label_class")
              .form-inline
                b-form-input(size="sm", :type="client_auth_input.type", v-model="value.client_auth_input", :placeholder="client_auth_input.placeholder", :state="error_msg_list.client_auth_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 デバイス
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.client_auth_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{client_auth_input.description}}
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="client_auth_ip.label", :label-class="client_auth_ip.label_class")
              b-form-textarea(:state="error_msg_list.client_auth_ip.error_msg.length === 0 ? null : false", v-model="value.client_auth_ip", rows="4")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.client_auth_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{client_auth_ip.description}}
          b-form-group.ml-4.border-top.border-primary(style="height: 0px;")
          b-form-text.ml-4 ※併用できるセキュリティオプションサービスは、Basic認証と接続元IPアドレス制限のみとなります。
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- メールサービス
        h5#mail-service.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.mail_service", @change="toggleMailService")
            h5.font-weight-bold メールサービス
        b-collapse#collapse-mail-service(v-model="mailServiceIsOpen")
          //- WebARENA
          b-form-checkbox.ml-4(v-model="value.web_arena", @change="toggleWebArena", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{web_arena.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/mail/", target="_blank") 詳細はこちら ＞
          b-collapse#collapse-web-arena.sub-b-collapse(v-model="webArenaIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="web_arena_domain.label", :label-class="web_arena_domain.label_class")
              .form-inline
                b-form-input(size="sm", :type="web_arena_domain.type", v-model="value.web_arena_domain", :placeholder="web_arena_domain.placeholder", :state="error_msg_list.web_arena_domain.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.web_arena_domain.error_msg") {{error_msg}}
            b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="web_arena_input.label", :label-class="web_arena_input.label_class")
              .form-inline
                b-form-input(size="sm", :type="web_arena_input.type", v-model="value.web_arena_input", :placeholder="web_arena_input.placeholder", :state="error_msg_list.web_arena_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 アカウント
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.web_arena_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{web_arena_input.description}}
            p.mb-2.ml-3
              a(
                href="https://www.desknets.com/cloud/article_cloudmail.pdf",
                target="_blank"
              ) ＞ WebARENA利用約款
          //- CYBERMAILΣ
          b-form-checkbox.ml-4(v-model="value.cyber", @change="toggleCyber", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{cyber.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber.error_msg") {{error_msg}}
          b-collapse#collapse-cyber.sub-b-collapse(v-model="cyberIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_input.label", :label-class="cyber_input.label_class")
              .form-inline
                b-form-input(size="sm", :type="cyber_input.type", v-model="value.cyber_input", :placeholder="cyber_input.placeholder", :state="error_msg_list.cyber_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 アカウント
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{cyber_input.description}}
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_capacity.label", :label-class="cyber_capacity.label_class")
              .form-inline
                b-form-select(v-model="value.cyber_capacity", :options="cyber_capacity.options", value-field="value", text-field="name", :state="error_msg_list.cyber_capacity.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_capacity.error_msg") {{error_msg}}
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_option.label", :label-class="cyber_option.label_class")
              b-form-checkbox(:state="error_msg_list.cyber_option.error_msg.length === 0 ? null : false", v-model="value.cyber_option[0]") {{cyber_option.options[0].label}}
              b-form-text {{cyber_option.options[0].description}}
              b-form-checkbox.mt-3(:state="error_msg_list.cyber_option.error_msg.length === 0 ? null : false", v-model="value.cyber_option[1]") {{cyber_option.options[1].label}}
              b-form-text {{cyber_option.options[1].description}}
              b-form-checkbox.mt-3(:state="error_msg_list.cyber_keep_period.error_msg.length === 0 ? null : false", v-model="value.cyber_option[2]") {{cyber_option.options[2].label}}
              b-collapse(v-model="value.cyber_option[2]")
                .form-inline
                  b-form-select.mt-1.ml-3(v-model="value.cyber_keep_period", :options="cyber_option.options[2].options", value-field="value", text-field="name", size="sm", :state="error_msg_list.cyber_keep_period.error_msg.length === 0 ? null : false")
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_keep_period.error_msg") {{error_msg}}
              b-form-checkbox.mt-3(v-model="value.cyber_option[3]") {{cyber_option.options[3].label}}
              .form-inline
                p.mt-3 {{cyber_option.options[3].description_1}}
                a(href="https://www.desknets.com/neo/inquiry/", target="_blank") お問合せ
                p {{cyber_option.options[3].description_2}}
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_option.error_msg") {{error_msg}}
            p.mb-2.ml-3
              a(
                href="https://www.cybersolutions.co.jp/admission/admission-CYBERMAILSIGMA.pdf",
                target="_blank"
              ) ＞ CYBERMAILΣ利用約款
          b-form-group.ml-4.border-top.border-primary(style="height: 0px;")
          b-form-text.ml-4 ※メールサービスは、メールサーバーのクラウド化をご希望のお客さま向けのオプションサービスです。
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- メールセキュリティサービス
        h5#mail-security-service.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.mail_security_service", @change="toggleMailSecurityService")
            h5.font-weight-bold メールセキュリティサービス
        b-collapse#collapse-mail-security-service(v-model="mailSecurityServiceIsOpen")
          //- MAILGATES Σ
          b-form-checkbox.ml-4(v-model="value.mailgates", @change="toggleMailgates", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{mailgates.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/#mailgates", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.mailgates.error_msg") {{error_msg}}
          b-collapse#collapse-mailgates.sub-b-collapse(v-model="mailgatesIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="mailgates_domain.label", :label-class="mailgates_domain.label_class")
              .form-inline
                b-form-input(size="sm", :type="mailgates_domain.type", v-model="value.mailgates_domain", :placeholder="mailgates_domain.placeholder", :state="error_msg_list.mailgates_domain.error_msg.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.mailgates_domain.error_msg") {{error_msg}}
              b-form-text.mt-0 {{mailgates_domain.description}}
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="mailgates_input.label", :label-class="cyber_input.label_class")
              .form-inline
                b-form-input(size="sm", :type="mailgates_input.type", v-model="value.mailgates_input", :placeholder="mailgates_input.placeholder", :state="error_msg_list.mailgates_input.error_msg.length === 0 ? null : false")
                b-form-text.ml-1.mb-2 アカウント
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.mailgates_input.error_msg") {{error_msg}}
              b-form-text.mt-0 {{mailgates_input.description}}
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="mailgates_option.label", :label-class="mailgates_option.label_class")
              b-form-checkbox(:state="error_msg_list.mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[0]") {{mailgates_option.options[0].label}}
              b-form-text {{mailgates_option.options[0].description}}
              b-form-checkbox.mt-3(:state="error_msg_list.mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[1]") {{mailgates_option.options[1].label}}
              b-form-text(text-variant="danger") {{mailgates_option.options[1].caution}}
              b-form-text {{mailgates_option.options[1].description}}
              b-form-checkbox.mt-3(:state="error_msg_list.mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[2]") {{mailgates_option.options[2].label}}
              b-form-text(text-variant="danger") {{mailgates_option.options[2].caution}}
              b-form-text {{mailgates_option.options[2].description}}
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.mailgates_option.error_msg") {{error_msg}}
            p.mb-2.ml-3
              a(
                href="https://www.cybersolutions.co.jp/admission/admission-MAILGATESSIGMA.pdf",
                target="_blank"
              ) ＞ MAILGATES Σ利用約款
          b-form-group.ml-4.border-top.border-primary(style="height: 0px;")
          b-form-text.ml-4 ※メールセキュリティサービスは、ゲートウェイ型のメールセキュリティ対策をご希望のお客さま向けのオプションサービスです。
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        //- ご希望サブドメイン名
        h5#sub-domain.font-weight-bold.ml-3(:class="title_class") ご希望サブドメイン名
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="sub_domain.label", :label-class="sub_domain.label_class")
          .form-inline
            b-form-input.mb-2(size="sm", :type="sub_domain.type", v-model="value.sub_domain", :state="error_msg_list.sub_domain.error_msg.length === 0 ? null : false", @change="domainCheck()")
            b-form-text.ml-1.mb-2 .dn-cloud.com
          b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.sub_domain.error_msg") {{error_msg}}
          b-form-text.description-text-position {{sub_domain.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        //- 無料お試し版からのデータ移行
        h5#migration-url.font-weight-bold.ml-3(:class="title_class") 無料お試し版からのデータ移行
        b-form-checkbox.ml-4(v-model="value.migration", @change="toggleMigration", :state="error_msg_list.migration.error_msg.length === 0 ? null : false")
          .form-inline
            b-form-text.label-font-size.mt-0 {{migration.label}}
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.migration.error_msg") {{error_msg}}
          b-form-text.font-weight-bold(text-variant="danger") {{migration.description}}
        b-collapse#collapse-migration.sub-b-collapse(v-model="migrationIsOpen")
          b-form-group.align-content.mt-2(label-cols="4", label-align="right", label-size="sm", :label="migration_url.label", :label-class="migration_url.label_class")
            b-form-input(size="sm", type="text", v-model="value.migration_url", :placeholder="migration_url.placeholder", :state="error_msg_list.migration_url.error_msg.length === 0 ? null : false", maxlength="128")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.migration_url.error_msg") {{error_msg}}
            //- .form-inline
            //-  b-form-text 試使用環境のURLをコピーする方法は
            //-  a(href="/migration_help.html", style="font-size: 80%; margin-top: 4px;", target="_blank") こちら
            //-  b-form-text から
          //- b-form-group.align-content.mt-4(label-cols="4", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
          //-   .form-inline
          //-     b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
          //-     select-datetime(v-model="migration_datetime.value", @done="setDateTime")
          //- b-form-group.align-content.mt-2(label-cols="4", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
          //-   b-form-text.mb-2.datetime-text {{showMigrationTime}}
          b-form-group.white-space.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
            .form-inline
              b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
              select-datetime(v-model="migration_datetime.value", @done="setDateTime")
          b-form-group.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
            b-form-text.mb-2.datetime-text {{showMigrationTime}}
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.migration_datetime.error_msg") {{error_msg}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        div(v-if="!migrationIsOpen")
          //- ご利用開始希望日
          h5#preferred-date.font-weight-bold.ml-3(:class="title_class") ご利用開始希望日
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="preferred_date.label", :label-class="preferred_date.label_class")
            b-form-datepicker.mb-2.datepicker-size(size="sm", v-model="value.preferred_date", :min="preferred_date.min", :max="preferred_date.max", :date-disabled-fn="dateDisabled", :placeholder="preferred_date.placeholder", :hide-header="true", :date-format-options="preferred_date.format_option")
            b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.preferred_date.error_msg") {{error_msg}}
            b-form-text.description-text-position {{preferred_date.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        //- お見積番号
        h5#estimate.font-weight-bold.ml-3(:class="title_class") お見積番号
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="estimate.label", :label-class="estimate.label_class")
          .form-inline
            b-form-text.mr-1 No.
            b-form-textarea.mb-2.estimate-size(:state="error_msg_list.estimate.error_msg.length === 0 ? null : false", v-model="value.estimate", rows="3")
          b-form-text.error-text-position.mb-1.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.estimate.error_msg") {{error_msg}}
          b-form-text.description-text-position(text-variant="danger") {{estimate.description_1}}
          b-form-text.description-text-position {{estimate.description_2}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        //- 備考
        h5#remarks.font-weight-bold.ml-3(:class="title_class") 備考
        b-container.sub-b-container
          b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="remarks.label", :label-class="remarks.label_class")
            b-form-textarea(v-model="value.remarks", rows="4")
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.remarks.error_msg") {{error_msg}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
    b-row
      b-col
        //- サービス利用約款など
        h5#provision.font-weight-bold.ml-3(:class="title_class") サービス利用約款など
        b-container.sub-b-container
          p
            a(href="https://www.desknets.com/cloud/article.pdf", target="_blank") ＞ desknet'sクラウドサービス利用約款
          p
            b-link(href="/tos.pdf", target="_blank") ＞ クラウド版サポートサイト利用規約
          b-form-textarea.white-space(v-model="provision.value", :disabled="true", rows="6")
          b-form-group.mt-3.mb-0.align-content.text-danger(label-cols="12", label-align="left", label-size="sm", :label="provision.label")
          b-form-checkbox.mx-auto(v-model="value.provision_check", @change="toggleNextButtonDisabled") {{provision_check.label}}
</template>

<script>
/* eslint-disable */
import SelectDatetime from "@/components/firstOrder/SelectDatetime";
import Api from "@/repositories/api";

const c204SubdomainCheckRepository = Api.get("c204SubdomainCheck")

export default {
  name: "ContractNeoForm",
  props: {
    value: { type: Object, required: false },
    error_msg_list: { type: Object, required: false }
  },
  components: {
    SelectDatetime
  },
  // 画面表示時処理(DOM作成前に実行)
  created() {
    // AppSuiteを含むプランの場合、AppSuiteのユーザー数を初期値にする
    if (['standard'].indexOf(this.value.plan_name) !== -1) {
      this.value.app_suite_user = null;
    }

    // 今日の日付の取得
    let currentDate = new Date();

    // 開始日(Dateオブジェクト)
    let startDate = new Date(currentDate);
    // 開始日(YYYY-MM-DD)
    let formedStartDate = ''

    // 祝日データを取得
    const holiday = this.getHolidays()

    // 本日から空ける必要のある営業日数(N日目が開始日)
    let preparationCount = this.getPreparationDayCount()

    // datepickerの最小値を作成
    for (let i = 0; i <= preparationCount; i++) {
      // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む

      // YYYY-MM-DD の形式にする
      formedStartDate =  startDate.getFullYear()
          + "-" + ("00" + (startDate.getMonth() + 1)).slice(-2)
          + "-" + ("00" + startDate.getDate()).slice(-2)

      // 土曜日または日曜日または祝日の場合はスキップ
      if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
        i--
      }

      // 最終日ではない場合は翌日へ
      if (i < preparationCount) {
        startDate.setDate(startDate.getDate() + 1)
      }
    }
    this.preferred_date.min = formedStartDate

    // datepickerの最大値を作成
    let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
    this.preferred_date.max = maxDate.getFullYear()
        + "-" + ("00" + (maxDate.getMonth() + 1)).slice(-2)
        + "-" + ("00" + maxDate.getDate()).slice(-2)

    //
    //---------------------------------------------------------
    // サービス内容入力画面に戻ってきたとき、元々開いていたオプションを開く
    //---------------------------------------------------------
    //

    // オプションサービス チェックボックスを開く
    if (this.value.option_service === true) {
      this.toggleOptionService()
      // CLOUZAチェックボックスを開く
      if (this.value.clouza_check === true) {
        this.toggleClouza()
      }
      // ディスク増設チェックボックスを開く
      if (this.value.option_disk === true) {
        this.toggleDisk()
      }
      // Sync for smartphoneチェックボックスを開く
      if (this.value.option_sync === true) {
        this.toggleSync()
      }
      // desknet'sドライブ ディスク増設チェックボックスを開く
      if (this.value.option_dn_drive === true) {
        this.toggleDnDrive()
      }
    }

    // セキュリティオプションを開く
    if (this.value.security_option === true) {
      this.toggleSecurityOption()

      // BASIC認証を開く
      if (this.value.basic_auth === true) {
        this.toggleBasic()
      }
      // 接続元IPアドレス制限を開く
      if (this.value.ip_restrictions === true) {
        this.toggleIpRestrictions()
      }
      // セキュアブラウザを開く
      if (this.value.secure_browser === true) {
        this.toggleSecureBrowser()
      }
      // クライアント認証を開く
      if (this.value.client_auth === true) {
        this.toggleClientAuth()
      }
    }

    // メールサービスチェックボックスを開く
    if (this.value.mail_service === true) {
      this.toggleMailService()
      // WebARENAチェックボックスを開く
      if (this.value.web_arena === true) {
        this.toggleWebArena()
      }
      // CYBERMAILΣチェックボックスを開く
      if (this.value.cyber === true) {
        this.toggleCyber()
      }
    }

    // メールセキュリティサービスチェックボックスを開く
    if (this.value.mail_security_service === true) {
      this.toggleMailSecurityService()
      // MAILGATES Σチェックボックスを開く
      if (this.value.mailgates === true) {
        this.toggleMailgates()
      }
    }

    // 無料お試し版からのデータ移行を開く
    if (this.value.migration === true) {
      this.toggleMigration()

      // 作業日時を表示する
      this.migration_datetime.value.date = this.value.migration_date
      this.migration_datetime.value.start_time = this.value.migration_time_from
      this.migration_datetime.value.end_time = this.value.migration_time_to
    }
  },
  /**
   * DOM作成後に実行される処理
   */
  mounted() {
    // アンカーまでスクロールする
    this.scrollToAnchor(this.$route.hash)
  },
  data() {
    // 必須のラベル
    const required_label_class = "py-05 mb-4 required-label-after";

    // 任意のラベル
    const elective_label_class = "py-05 mb-4 elective-label-after";

    return {
      title_class: "border-top border-bottom neo-title-bg-color py-2",
      data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",

      option_data_class: "py-2 border-top border-primary",
      option_data_last_class: "py-2 border-top border-bottom border-primary",

      optionServiceIsOpen: false,
      optionClouzaIsOpen: false,
      optionDiskIsOpen: false,
      optionSyncIsOpen: false,
      // desknet'sドライブ ディスク増設 開フラグ
      optionDnDriveIsOpen: false,
      securityOptionIsOpen: false,
      basicIsOpen: false,
      ipRestrictionsIsOpen: false,
      secureBrowserIsOpen: false,
      clientAuthIsOpen: false,
      mailServiceIsOpen: false,
      webArenaIsOpen: false,
      cyberIsOpen: false,
      mailSecurityServiceIsOpen: false,
      mailgatesIsOpen: false,
      migrationIsOpen: false,

      option_disk_sum: 20,
      // desknet'sドライブ ディスク増設容量（合計）
      option_dn_drive_disk_sum: 20,
      secureBrowserTerminalDisabled: true,

      plans: {
        'light': { title: 'ライト', price: 660, services:['neo'], plan:'light'},
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan:'standard' },
        '': { title: '', price: '', services: [], plan: '' }
      },

      plan: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        maxlength: 5
      },
      app_suite: {
        label: "ユーザー数",
        label_class: elective_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーから、desknet's NEOの契約ユーザー数までのご契約となります。\n" +
          "※ご契約単位は1ユーザー単位です。"
      },
      web_conferencing: {
        label: "会議室数",
        label_class: elective_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約会議室は1会議室から、最大10会議室までのご契約となります。\n" +
          "※ご契約単位は1会議室単位です。"
      },

      option_service: {
        checked: false,
      },
      // RoomMgr
      option_room_mgr: {
        checked: false,
        label: "RoomMgr（￥22,000/月）",
        description: "※SAML認証との併用はできません。\n" +
            "※クライアント認証オプションと併用する場合、RoomMgrへログインするタブレットへ証明書をインストールしていただくか、\n" +
            "タブレットからの接続は特定のIPアドレス/ネットワークからとして、クライアント認証を除外する手続きを行ってください。",
      },
      option_expense_settlement: {
        checked: false,
        label: "交通費・経費精算（1ユーザー￥110/月）",
        description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
      },
      clouza_check: {
        checked: false,
        label: "タイムカード＋CLOUZA（10ユーザー￥2,200/月）",
      },
      clouza_input: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は20ユーザーです。\n" +
          "※ご契約単位は10ユーザー単位です。"
      },
      clouza_company_code: {
        label: "会社コード",
        label_class: elective_label_class,
        type: "text",
        value: "",
        placeholder: "",
        description: "※CLOUZAお試し環境からの引き継ぎがある場合のみ入力してください。"
      },
      paid_leave_option: {
        checked: false,
        label: "有休管理＋申請承認オプション 　(10ユーザー￥1,650/月)",
        description: "※タイムカード＋CLOUZA本体の契約ユーザー数と同数でのご契約となります。"
      },
      option_disk: {
        checked: false,
        label: "ディスク増設（20GBあたり￥2,200/月）",
      },
      option_disk_size: {
        label: "増設容量",
        label_class: required_label_class,
        type: "text",
        value: "1",
      },
      option_sync: {
        checked: false,
        label: "Sync for smartphones（1ユーザー￥220/月）"
      },
      option_sync_input: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。"
      },
      // desknet'sドライブ ディスク増設
      option_dn_drive: {
        checked: false,
        label: "desknet'sドライブ ディスク増設（20GBあたり￥2,200/月）",
      },
      // desknet'sドライブ ディスク増設容量
      option_dn_drive_disk_size: {
        label: '増設容量',
        label_class: required_label_class,
        type: 'text',
        value: '1',
      },

      basic_auth: {
        checked: false,
        label: "BASIC認証（無償）"
      },
      basic_auth_user: {
        label: "ユーザーID",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角英数字）",
      },
      basic_auth_password: {
        label: "パスワード",
        label_class: required_label_class,
        type: "password",
        value: "",
        placeholder: "（半角英数字）",
      },
      basic_auth_ip: {
        label: "認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "elective-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24"
      },
      ip_restrictions: {
        label: "接続元IPアドレス制限（無償）",
        checked: false,
      },
      ip_restrictions_ip: {
        label: "接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続を許可する：192.0.2.201\n" +
          "　特定のネットワークからの接続を許可する：192.0.2.0/24"
      },
      secure_browser: {
        label: "セキュアブラウザ（1ユーザー￥110/月 または 1デバイス￥385/月）",
        checked: false
      },
      secure_browser_terminal: {
        label: "端末認証",
        label_class: required_label_class,
        value: "01",
        options: [
          {
            value: "01",
            text: "端末認証なし",
            description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
          },
          {
            value: "02",
            text: "端末認証あり",
            description: "※最低契約デバイス数は5デバイスです。\n" +
              "※ご契約単位は1デバイス単位です"
          }
        ]
      },
      secure_browser_device: {
        type: "text",
        value: "",
        placeholder: "（半角数字）"
      },
      secure_browser_ip: {
        label: "セキュアブラウザを適用しないIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24"
      },
      client_auth: {
        label: "クライアント認証（1デバイス￥220/月）",
        checked: false
      },
      client_auth_input: {
        label: "デバイス数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最低契約デバイス数は5デバイスです。\n" +
          "※ご契約単位は1デバイス単位です。",
      },
      client_auth_ip: {
        label: "認証を除外するIPアドレス(1行に1件ずつ記入、最大50件まで)",
        label_class: "elective-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24"
      },

      web_arena: {
        label: "WebARENA（1アカウント￥220/月）",
        checked: false,
      },
      web_arena_domain: {
        label: "利用ドメイン名",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角英数字）",
      },
      web_arena_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最小25～最大1000アカウント迄ご利用可能です。\n※ご契約単位は1アカウント単位です。"
      },
      cyber: {
        label: "CYBERMAILΣ（1アカウント￥220～/月、初期￥55,000～）",
        checked: false,
      },
      cyber_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。"
      },
      cyber_capacity: {
        label: "メールボックス容量",
        label_class: required_label_class,
        value: "00",
        options: [
          { value: "00", name: "（容量を選択してください）" },
          { value: "01", name: "5GB" },
          { value: "02", name: "10GB" },
          { value: "03", name: "50GB" },
          { value: "04", name: "100GB" }
        ]
      },
      cyber_option: {
        label: "オプション",
        label_class: elective_label_class,
        options: [
          { label: "情報漏えい対策(有償)", value: "01", description: "※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイル全文チェック)および個人情報漏洩 対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。" },
          { label: "添付ファイル暗号化・分離(有償)", value: "02", description: "※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。" },
          {
            label: "メールアーカイブ＆監査(有償)",
            value: "03",
            options: [
              {value: "00", name: "（保存期間を選択してください）"},
              {value: "01", name: "5年保存"},
              {value: "02", name: "7年保存"},
            ],
          },
          { label: "クラウド型サンドボックス(有償)", value: "04", description_1: "上記以外のオプション(メール無害化など)をご希望のお客様は、弊社まで", description_2: "ください。" }
        ]
      },

      mailgates: {
        label: "MAILGATES Σ（1アカウント￥110～/月、初期￥55,000～）",
        checked: false,
      },
      mailgates_domain: {
        label: "利用ドメイン名",
        label_class: required_label_class,
        description: "※半角英数字および「-」と「.」のみで入力してください。",
        placeholder: '（半角英数字）',
        error_msg: []
      },
      mailgates_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。",
      },
      mailgates_option: {
        label: "オプション",
        label_class: required_label_class,
        options: [
          { label: "アンチウイルス・スパム＋サンドボックス", value: "01", description: "※ウイルス・迷惑メール対策(アンチウイルス・スパム)、フィッシング対策(URLフィルタリング)、なりすまし対策(SPF DKIM DMARC設定)、BEC対策(アドレス詐称判定)、サンドボックスを利用できます。" },
          { label: "誤送信対策・審査", value: "02", caution: '添付ファイル暗号化・分離と同時に申込みできません。', description: "※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイルの全文チェック)および個人情報漏洩対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。" },
          { label: "添付ファイル暗号化・分離", value: "03", caution: '誤送信対策・審査と同時に申込みできません。',  description: "※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。" }
        ],
      },

      sub_domain: {
        label: "サブドメイン名",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "",
        description: "※お客さまを識別するアクセスURLの一部になります。\n" +
          "※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。"
      },

      estimate: {
        label: "お見積番号",
        label_class: elective_label_class,
        value: "",
        description_1: "既に弊社から見積を取得されている場合、必ずご記入ください。",
        description_2: "※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。"
      },

      migration: {
        checked: false,
        label: "希望する",
        description: "※移行作業中は試使用環境が停止します。"
      },
      migration_url: {
        label: "試使用環境URL",
        label_class: required_label_class + " px-0",
        value: "",
        placeholder: "https://dn06110.dncloudtrial.com/cgi-bin/123456/dneo/dneo.cgi"
      },
      migration_choice: {
        label: "作業日時を選択してください",
        label_class: required_label_class + " px-0",
      },
      migration_datetime: {
        label: "選択日時",
        label_class: "py-05 mb-4 datetime-label",
        value: {
          date: '',
          start_time: '',
          end_time: '',
        },
      },

      preferred_date: {
        label: "希望日",
        label_class: required_label_class,
        value: "",
        placeholder: "（カレンダーから選択）",
        min: "",
        max: "",
        format_option: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
        description: "※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。\n" +
          "※ご利用開始希望日が弊社休業日の場合、翌営業日のご希望として承ります。\n" +
          "※ご利用開始希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。"
      },

      remarks: {
        label: "弊社への連絡事項などございましたら、こちらにご記入ください。",
        label_class: "elective-label-after",
        value: "",
      },

      provision: {
        label: "お申込みいただくにあたり、各種サービス約款および上記の各条項にご同意ください。",
        value: "個人情報の取得目的\n" +
          "１．当社は、当Webサイトにおいて、下記に記載する目的でお客さまより個人情報をご提供いただきます。\n" +
          "　①　お客さまからの資料請求、お問合せ、製品購入申込み等々に対する当社からの返信・送付\n" +
          "　②　当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付および製品に関するその他の情報提供\n" +
          "　③　サービスと製品開発のための統計用データとしての利用\n" +
          "　④　カスタマーハラスメント等への対応・事実確認\n" +
          "\n" +
          "\n" +
          "反社会的勢力の排除について\n" +
          "１．お客さまは、現在または将来にわたって、下記のいずれにも該当しないことを表明、確約するものとします。\n" +
          "　①　暴力団\n" +
          "　②　暴力団員\n" +
          "　③　暴力団員でなくなった時から５年を経過しない者\n" +
          "　④　暴力団準構成員\n" +
          "　⑤　暴力団関係企業\n" +
          "　⑥　総会屋等、社会運動標ぼうゴロまたは特殊知能暴力集団\n" +
          "　⑦　その他上記各号に準ずるもの\n" +
          "２．お客さまは、自らまたは第三者を利用し、下記のいずれかに該当する行為を行わないことを表明、確約するものとします。\n" +
          "　①　暴力的な要求行為\n" +
          "　②　法的な責任を超えた不当な要求行為\n" +
          "　③　取引に関して、脅迫的な言動をし、または暴力を用いる行為\n" +
          "　④　風説を流布し、偽計または威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為\n" +
          "　⑤　その他上記各号に準ずる行為\n" +
          "３．お客さまが上記各項のいずれかに反したと認められることが判明した場合、および上記各項の表明、確約が虚偽の申告であることが判明した場合、当社は、催告その他の手続を要しないで、契約の解除その他の当社が必要と判断する対応をとることができます。\n" +
          "４．お客さまは、前項による契約の解除等について、一切異議を申し立てず、また賠償ないし補償を求めないとともに、これより当社に損害が生じた場合は、これを賠償するものします。\n" +
          "\n" +
          "\n" +
          "管轄裁判所\n" +
          "１．本条項に基づく契約は日本法に準拠し、お客さまと当社の間で訴訟の必要が生じた場合には、訴額に応じて、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。"
      },
      provision_check: {
        checked: false,
        label: "上記の条項に同意します。"
      },
    }
  },
  methods: {
    toggleOptionService() {
      this.optionServiceIsOpen = !this.optionServiceIsOpen;
    },
    toggleClouza() {
      this.optionClouzaIsOpen = !this.optionClouzaIsOpen;
    },
    toggleDisk() {
      this.optionDiskIsOpen = !this.optionDiskIsOpen;
    },
    toggleSync() {
      this.optionSyncIsOpen = !this.optionSyncIsOpen;
    },
    /**
     * desknet'sドライブ ディスク増設 開閉
     */
    toggleDnDrive() {
      this.optionDnDriveIsOpen = !this.optionDnDriveIsOpen;
    },
    toggleSecurityOption() {
      this.securityOptionIsOpen = !this.securityOptionIsOpen;
    },
    toggleBasic(){
      this.basicIsOpen = !this.basicIsOpen;
    },
    toggleIpRestrictions() {
      this.ipRestrictionsIsOpen = !this.ipRestrictionsIsOpen;
    },
    toggleSecureBrowser() {
      this.secureBrowserIsOpen = !this.secureBrowserIsOpen;
    },
    toggleClientAuth() {
      this.clientAuthIsOpen = !this.clientAuthIsOpen;
    },
    toggleMailService() {
      this.mailServiceIsOpen = !this.mailServiceIsOpen;
    },
    toggleWebArena() {
      this.webArenaIsOpen = !this.webArenaIsOpen;
    },
    toggleCyber() {
      this.cyberIsOpen = !this.cyberIsOpen
    },
    toggleMailSecurityService() {
      this.mailSecurityServiceIsOpen = !this.mailSecurityServiceIsOpen;
    },
    toggleMailgates() {
      this.mailgatesIsOpen = !this.mailgatesIsOpen
    },
    toggleMigration() {
      this.migrationIsOpen = !this.migrationIsOpen;
    },
    toggleNextButtonDisabled() {
      this.$emit('method')
    },
    changeSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.option_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.option_disk_sum = value * 20;
      }
    },
     /**
     * desknet'sドライブ ディスク増設容量の変更を反映する
     */
    changeDnDriveSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.option_dn_drive_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.option_dn_drive_disk_sum = value * 20;
      }
    },
    secureBrowserTerminalChange(value) {
      // 端末認証なし
      if (value === "01") {
        // デバイス数を空にする
        this.secure_browser_device.value = "";

        // デバイス数の入力ができないようにする
        this.secureBrowserTerminalDisabled = true;
      }
      // 端末認証あり
      else {
        // デバイス数の入力ができるようにする
        this.secureBrowserTerminalDisabled = false;
      }
    },
    // datepickerの土日を選択不可にする
    dateDisabled(ymd, date) {
      // 曜日を取得する（日曜日 - 土曜日：0 - 6）
      const iWeekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
          + "-" + ("00" + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 日曜日と土曜日と祝日の場合、選択不可にする
      return iWeekday === 0 || iWeekday === 6 || holiday.includes(day)
    },
    setDateTime() {
      // モーダルでOKボタンが押下されたら、選択した作業日時を設定値にする
      this.value.migration_date = this.migration_datetime.value.date
      // propsのmigration_fromにデータ移行作業時刻（から）を保存する
      this.value.migration_time_from = this.migration_datetime.value.start_time
      // propsのmigration_toにデータ移行作業時刻（まで）を保存する
      this.value.migration_time_to = this.migration_datetime.value.end_time
    },
    /**
     * サブドメインチェック処理を行う
     */
    domainCheck() {
      // 初期化
      let sSubdomainName = ''
      let sSubdomainType = ''

      // サブドメインチェック処理のエラーメッセージを空にする
      this.error_msg_list.sub_domain.error_msg = []

      // 変数にNEOのサブドメイン名の値を代入する
      sSubdomainName = this.value.sub_domain
      sSubdomainType = '0'

      // サブドメインチェック処理を呼び出す
      c204SubdomainCheckRepository.get(encodeURIComponent(sSubdomainName), sSubdomainType)
          .catch((err) => {
            // 共通のエラー処理
            this.apiError(err, '入力チェック処理', "ContractNeo")

            // エラーメッセージを生成する
            if (err.response !== null && err.response !== undefined) {
              const errList = err.response.data.error_list
              let target = 'sub_domain'
              errList.forEach((sErrorMessage) => {
                this.responseErrorMessage(target, sErrorMessage.error_msg)
              })
            }
          })
    },
    responseErrorMessage(target, msg) {
      switch (target) {
        // ご希望サブドメイン名
        case 'sub_domain':
          this.error_msg_list.sub_domain.error_msg.push(msg)
          break
        default:
          break
      }
    }
  },
  computed: {
    showMigrationTime() {
      let sDatetime = '選択してください'

      if (this.migration_datetime.value.date) {
        // 形式は「2021年11月14日 11:00 - 12:00」
        const arDay = this.migration_datetime.value.date.split('-')
        const sTime = this.migration_datetime.value.start_time + ':00 - ' + this.migration_datetime.value.end_time + ':00'

        sDatetime = arDay[0] + '年' + arDay[1] + '月' + arDay[2] + '日 ' + sTime
      }

      return sDatetime
    },
  }
}
</script>

<style scoped>
.neo-title-bg-color {
  background-color: #f2ffff;
}

.datepicker-size {
  width: 210px;
}
::v-deep .datetime-label {
  padding-right: 53px !important;
}
.datetime-text {
  font-size: 1rem;
  margin-top: 1px;
}
.description-text-position {
  margin-top : -3px;
}
.detail-button-size {
  height: 22px;
  font-size: 11px;
  display: flex;
  align-items: center;
}

.estimate-size {
  width: 400px !important;
}

.label-font-size {
  font-size: 16px;
}

.neo-b-collapse {
  background-color: #f2ffff;
}
.neo-image-size {
  width: 300px;
  height: 110px;
}

.option-disk-form-class {
  width: 85px !important;
}

.paid-leave-option-description-font {
  font-size: 12.8px;
}
.paid-leave-option-font {
  font-size: 0.875rem;
}

.sub-b-collapse {
  width: 650px;
  padding: 5px;
  background-color: #ffffd3;
  margin-left: 15px;
}
.sub-b-container {
  width: 650px;
  padding: 5px;
  margin-left: 15px;
}

.white-space {
  white-space: pre-line !important;
}

.logo_desknets {
  width:200px;
  height: auto;
}
.logo_chatluck {
  width:200px;
  height: auto;
}
.logo_appsuite {
  width:200px;
  height: auto;
}
.plan-title-size {
  font-size: 2rem;
}

.error-text-position {
  margin-top : -6px;
}
</style>
